module.exports = __webpack_public_path__ + "static/media/dus_ext.594fc903.png";